import React from "react";
import "cross-fetch/polyfill";
import styled from "styled-components";
import { breakpoints } from "../styledHelpers";
import { useSearchPageContext } from "../../components/pages/SearchPage/SearchPageContext";
import { BUTTON_SIZES, OutlineButton } from "../../components/elements/v2/Button/Button";
import { CONCIERGE_LISTINGS_PATH, getUserPath, USER_PROFILE_SORT_PATH } from "../paths";
import { SellerType } from "../../types/graphql-global-types";
import { SortBy } from "react-instantsearch";
import { sortByItems } from "./sorting";

export default function SearchSort({ ...props }) {
  const { isProfilePage, profilePage, isConciergePage } = useSearchPageContext();

  if (isProfilePage) {
    const isAdmin = profilePage.me?.isAdmin;
    const isMe = profilePage.person.isMe;
    const isProfessionalSeller = profilePage.person.sellerType === SellerType.professional_seller;
    if (isAdmin || (isMe && isProfessionalSeller))
      return (
        <SortListingsButton href={getUserPath(profilePage.person.username, USER_PROFILE_SORT_PATH)}>
          Sort Listings
        </SortListingsButton>
      );

    return null;
  }

  if (isConciergePage) {
    return (
      <SortListingsButton href={`${CONCIERGE_LISTINGS_PATH}${USER_PROFILE_SORT_PATH}`}>
        Sort Listings
      </SortListingsButton>
    );
  }

  return <SortDropdown items={sortByItems} />;
}

const SortDropdown = styled(SortBy)`
  &.ais-SortBy {
    position: relative;
    ::after {
      content: "\\25BC"; /* Unicode for a down arrow */
      position: absolute;
      right: 8px;
      top: 50%;
      pointer-events: none;
      transform: translateY(-50%) scaleX(1.2);
      font-size: 10px;
      color: #666;
    }
  }
  .ais-SortBy-select {
    background: transparent;
    border: none;
    padding: 8px 24px 8px 8px;
    outline-color: #111111;
    cursor: pointer;
    appearance: none;
    border-radius: 0;
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
  ${breakpoints.down("tablet")} {
    &.ais-SortBy {
      width: 100%;
      height: 100%;
      ::after {
        right: 12px;
      }
    }
    .ais-SortBy-select {
      width: 100%;
      height: 100%;
      border: 1px solid rgb(34, 34, 34);
      text-align: center;
      text-align-last: center;
      font-size: 14px;
      font-weight: 600;
      outline: none;
    }
  }
`;

const SortListingsButton = styled(OutlineButton).attrs({
  size: BUTTON_SIZES.SMALL,
})`
  ${breakpoints.down("tablet")} {
    width: 100%;
    height: 42px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
  }
`;
